<template>
  <div class="page-container">
    <div class="teacher-list" @scroll="handleScroll">
      <div class="teacher" v-for="item in state.finishList" :key="item.id" @click="handleGoDetail(item)">
        <van-image
          class="teacher-photo"
          mode="widthFix"
          :src="item.imagePhoto"
        ></van-image>
        <div class="teacher-name">{{ item.name }}</div>
        <div class="teacher-info">
          {{ item.title }}
        </div>
      </div>
      <EmptyDataCard
        style="margin-top: 88px"
        v-show="!state.finishList.length"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, reactive, ref } from "vue";
import EmptyDataCard from "@/components/EmptyDataCard.vue";
import { queryTeacherPageList } from "@/api/user";
import { useRoute, useRouter } from "vue-router";
export default defineComponent({
  name: "GaoBuTeacher",

  components: {
    EmptyDataCard,
  },

  setup() {
    const route = useRoute();

    const router = useRouter();

    console.log(route);

    const state = reactive({
      finishList: [],
      loading: false,
      isFinsh: false,
      page: {
        pageIndex: 1,
        pageSize: 10,
      },
    });
    onMounted(() => {
      queryTeacherPageListData();
    });

    function handleGoDetail(row) {
        console.log('row>>>>>', row);
        router.push({
            path: '/teacherDetail',
            query: {
                id: row.id,
                creatOrg: route?.query?.creatOrg
            }
        })
    }

    function handleScroll(event) {
      console.log('event>?>',event)
      const { scrollTop, scrollHeight, clientHeight, scrollLeft, offsetWidth } =
        event.target;
      const isBottom = scrollHeight - (scrollTop + clientHeight) <= 10; // 10是一个阈值，可以根据需要调整
      if (isBottom && !state.loading && !state.isFinsh) {
        state.loading = true;
        queryTeacherPageListData();
      }
    }

    const queryTeacherPageListData = async () => {
      try {
        const result = await queryTeacherPageList({
          page: {
            ...state.page,
          },
          createOrg: route?.query?.creatOrg,
          isBest: 1,
        });
        console.log("result:", result);
        if (result.code === "00") {
          state.finishList = [...state.finishList, ...result.data.list];
          if (state.page.pageIndex >= result.data.pages) {
            state.isFinsh = true;
            return;
          } else {
            state.loading = false;
            state.page.pageIndex++;
          }
        } else {
          state.finishList = [...state.finishList];
        }
      } catch (error) {
        console.log("error:>>>", error);
        state.finishList = [...state.finishList];
      }
    };

    return {
      state,
      handleScroll,
      handleGoDetail
    };
  },
});
</script>

<style lang="scss" scoped>
.page-container {
  background: #e9f1f8;
  height: 100vh;
  width: 100%;
  overflow-y: scroll;
  padding: 14px;

.teacher-list{
  display: flex;
  width: 100%;
  max-height: 100vh;
  flex-wrap: wrap;
  justify-content: flex-start;
  overflow-y: scroll;
}

.teacher {
  width: calc(50% - 48px);
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  margin-bottom: 12px;
  padding: 14px;
  margin-left: 4px;
}

.teacher-photo {
  width: 85px;
  height: 89px;
}

.teacher-name {
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 21px;
  color: #000000;
  margin-top: 10px;
}

.teacher-info {
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 15px;
  color: #616161;
  margin-top: 8px;
  white-space: nowrap;
  overflow: hidden;
}

}
</style>